import { List, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// routes
import getActionMensagemLida from 'src/actions/chats/getActionMensagemLida';

import getActionAceitarChat from '../../../actions/chats/getActionAceitarChat';
import {
  getChatInfoByChatId,
  getChatsAtendimento,
  getChatsFinalizados,
  getChatsGeral,
  getChatsPendente,
  getLoadMessagesInChat,
  getMensagensWhatsappDb,
  getMessagesWhatsapp,
  setChatInfo
} from '../../../redux/slices/chat';
import { useDispatch } from '../../../redux/store';
import { PATH_CHAT } from '../../../routes/paths';
// material
//
import ChatSearchItem from './ChatSearchItem';
import ChatPesquisaItem from 'src/sections/@chats/chat/ChatsListItem/ChatPesquisaItem';
import useAuth from 'src/hooks/useAuth';
import { useSnackbar } from 'notistack';
import ChatAtendimentoItem from 'src/sections/@chats/chat/ChatsListItem/ChatAtendimentoItem';


ChatSearchResults.propTypes = {
  query: PropTypes.string,
  results: PropTypes.array,
  onSelectContact: PropTypes.func
};

export default function ChatSearchResults({ results, isOpenSidebar }) {
  const { enqueueSnackbar } = useSnackbar();
  const { user, cliente } = useAuth();
  const dispatch = useDispatch();
  const { t } = useTranslation('chat');
  const isSuperVisor = user.level === "root";

  function buscarMessagesAndInfo(chat) {
    // setChatInfo antes do fetch: getMensagensWhatsappDb decide o canal pelo
    // chatInfo do store — na ordem antiga lia o chat anterior (Instagram abria
    // como whatsapp&numero= no 1o clique).
    if (chat) {
      dispatch(setChatInfo(chat));
    } else {
      dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
    }
    if (cliente.config.chat_source_db) {
      dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
    } else {
      dispatch(getMessagesWhatsapp(chat.sessao, chat.numeroCliente));
    }
  }

  function updateListAndReadMessage(chat) {
    getActionMensagemLida({ chatId: chat._id })
    dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
    dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, true));
  }

  const handlePegarChat = async (chat) => {
    try {
      if (chat?.direciona_usuarios.length === 0) {
        if (chat?.direciona_usuarios.includes(user.id)) {
          if (chat.statusRoom !== "Atendendo") {
            await getActionAceitarChat({ chatId: chat?._id, usuarioId: user.id })
            dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
            dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
            enqueueSnackbar(t('header.chatAccepted'), { variant: 'success' });
            buscarMessagesAndInfo(chat)
          } else {
            if (isSuperVisor) {
              await getActionAceitarChat({ chatId: chat?._id, usuarioId: user.id })
              dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
              dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
              enqueueSnackbar(t('header.chatAccepted'), { variant: 'success' });
              buscarMessagesAndInfo(chat);
            }
          }
          console.log('aqui 01A')
        } else {

          console.log('aqui 01')

          if (isSuperVisor) {
            getActionAceitarChat({ chatId: chat?._id, usuarioId: user.id })
            dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
            dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
            enqueueSnackbar(t('header.chatAccepted'), { variant: 'success' });
            // setChatInfo antes do fetch (mesmo motivo de buscarMessagesAndInfo).
            if (chat) {
              dispatch(setChatInfo(chat));
            } else {
              dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
            }
            if (cliente.config.chat_source_db) {
              dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
            } else {
              dispatch(getMessagesWhatsapp(chat.sessao, chat.numeroCliente));
            }
          } else {
            if (chat.statusRoom !== "Atendendo") {
              getActionAceitarChat({ chatId: chat?._id, usuarioId: user.id })
              dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
              dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
              enqueueSnackbar(t('header.chatAccepted'), { variant: 'success' });
              buscarMessagesAndInfo(chat)
            } else {
              enqueueSnackbar(t('searchResults.alreadyInService'), { variant: 'error' });
            }
          }

        }


      } else {

        await getActionAceitarChat({ chatId: chat?._id, usuarioId: user.id })
        dispatch(getChatsFinalizados(user.clienteId, user.id, user.setorId, 50, true));
        dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
        enqueueSnackbar(t('header.chatAccepted'), { variant: 'success' });
        buscarMessagesAndInfo(chat)
      }
    } catch (error) {
      console.log(error)
    }

  }

  const handleSelectConversation = async (chat) => {
    if (chat.direciona_usuarios.length === 0) {
      getActionMensagemLida({ chatId: chat._id })
      dispatch(getChatsAtendimento(user.clienteId, user.id, user.setorId, 10, true));
      dispatch(getChatsGeral(user.clienteId, user.id, user.setorId, 100, true));
    } else {
      if (isSuperVisor) {
        buscarMessagesAndInfo(chat);
        updateListAndReadMessage(chat)
      } else {
        if (chat.direciona_usuarios.includes(user.id)) {
          buscarMessagesAndInfo(chat);
          updateListAndReadMessage(chat)
        } else {
          enqueueSnackbar(t('searchResults.alreadyInService'), { variant: 'error' });
        }
      }

    }
  };

  return (
    <List>
      {results?.map(result => (
        <ChatAtendimentoItem
          user={user}
          searchItem={true}
          onSelectConversation={() => handleSelectConversation(result)}
          onAceitarChat={() => handlePegarChat(result)}
          isOpenSidebar={isOpenSidebar}
          chat={result}
        />

      ))}
    </List>
  );
}
